<template>
    <div>
        <h5 class="font-weight-bold">Módulo de Agendamento</h5>
        <p class="text-muted">Ative ou desative o módulo de Agendamento.</p>

        <load v-if="loading" mode="table" message="Carregando configuração" />
        <div v-else-if="erroCarregamento" class="alert alert-danger" role="alert">
            Não foi possível carregar a configuração.
            <button type="button" class="btn btn-link" @click="carregar">
                Tentar novamente
            </button>
        </div>
        <div v-else>
            <p aria-live="polite">
                Status:
                <strong :class="ativo ? 'text-success' : 'text-danger'">
                    {{ ativo ? 'Ativado' : 'Desativado' }}
                </strong>
            </p>
            <button
                type="button"
                class="btn"
                :class="ativo ? 'btn-danger' : 'btn-success'"
                :disabled="salvando"
                @click="alternar"
            >
                {{ salvando ? 'Salvando...' : (ativo ? 'Desativar módulo' : 'Ativar módulo') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            ativo: false,
            loading: true,
            salvando: false,
            erroCarregamento: false,
        };
    },
    mounted() {
        this.carregar();
    },
    methods: {
        async carregar() {
            this.loading = true;
            this.erroCarregamento = false;
            try {
                const response = await axios.get('api/dashboard/admin/agendamento/settings');
                this.ativo = response.data.ativo;
                this.$store.commit('pushSettings', { agendamento_ativo: this.ativo });
            } catch (error) {
                this.erroCarregamento = true;
            } finally {
                this.loading = false;
            }
        },
        async alternar() {
            if (this.salvando) return;
            this.salvando = true;
            try {
                const response = await axios.post('api/dashboard/admin/agendamento/settings', {
                    ativo: !this.ativo,
                });
                this.ativo = response.data.ativo;
                this.$store.commit('pushSettings', { agendamento_ativo: this.ativo });
                this.$snack.success({
                    button: false,
                    text: this.ativo ? 'Módulo de Agendamento ativado.' : 'Módulo de Agendamento desativado.',
                });
            } catch (error) {
                this.$snack.danger({
                    button: false,
                    text: 'Não foi possível salvar a configuração. Tente novamente.',
                });
            } finally {
                this.salvando = false;
            }
        },
    },
};
</script>
